<template>
    <div class="layout-book">

        <div class="uk-section uk-section-default uk-background-legible uk-background-cover uk-background-fixed uk-background-blend-multiply uk-padding-large hero" v-bind:style="{ backgroundImage: `url(${page.heroImage.large4x3})`}" v-if="!!page.heroImage && page.heroImage.id > 0">
            <div class="uk-grid uk-margin-xlarge-top" uk-grid>
                <div class="uk-light uk-width-1-2@l uk-width-3-5@m uk-width-1-1@xs uk-margin-xlarge-bottom">

                    <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                    <h1 class="uk-margin-small-top">{{page.title}}</h1>

                    <slot name="summary">
                        <p class="uk-text-lead" v-if="page.subtitle">{{page.subtitle}}</p>
                    </slot>

              </div>
            </div>
        </div>

        <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header" v-else>
          <div class="uk-light uk-container uk-container-small uk-text-center">

              <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
              <h1 class="uk-margin-small-top">{{page.title}}</h1>

              <slot name="summary">
                  <p class="uk-text-lead" v-if="page.subtitle">{{page.subtitle}}</p>
              </slot>

              <slot name="subheader"></slot>
          </div>
        </div>

        <!-- <FloatingBadge :text="page.summary" badgeClass="background-green"/> -->

        <div class="uk-section uk-section-small uk-background-darkest uk-text-center uk-light">
            <div class="uk-container uk-container-small">
                <h3 class="uk-margin-remove"><em class="text-green">{{page.summary}}</em></h3>
            </div>
        </div>

        <div class="uk-section uk-section-medium uk-background-white" v-if="page.content">
            <div class="uk-container uk-container-small">

                <div class="content" v-html="page.content"></div>

            </div>
        </div>

        <Testimonials :testimonials="(page && page.testimonialsArray) ? JSON.parse(page.testimonialsArray, true) : false" />

        <div class="uk-section uk-section background-blue uk-light">

            <div class="uk-container">

                <div class="text content" v-html="page.secondaryContent"></div>

                <div class="uk-text-center">

                    <!-- <h4>Book Price: <b>${{parseFloat(bookConfig.price).toFixed(2)}}</b></h4> -->

                    <form name="_xclick" class="uk-width-xlarge wp_accept_pp_button_form uk-margin-auto" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">

                        <h5>Your Donation Amount</h5>
                        <div class="uk-margin uk-grid-small uk-child-width-1-6 uk-grid">
                            <button class='uk-button uk-button-default item' v-for="(xamount, index) in amounts" :key="xamount.value" v-bind:class="{ 'active' : currentAmount.value == xamount.value, 'uk-width-1-1' : xamount.value === 0 }" @click.prevent="currentAmount = xamount">{{xamount.label}}</button>
                        </div>

                        <div class="uk-margin" v-if="currentAmount.value === 0">
                            <label>Enter Custom Amount</label>
                            <input type="text" v-model="customAmount" class="uk-input uk-text-center uk-width-1-1 custom-amount" placeholder="0.00" @focus="$event.target.select()" />
                        </div>

                        <!-- <h5>Donation Recurrence</h5> -->
                        <div class="uk-margin uk-grid-small uk-child-width-1-4 uk-grid uk-margin-medium-bottom">
                            <div v-for="(xrecur, index) in recurrence">
                                <label v-key="`recur-${index}`">
                                    <input :id="`recur-${index}`" v-model="recur" class="uk-radio" type="radio" :value="xrecur" />
                                    {{ xrecur.label }}
                                </label>
                            </div>
                            <!-- <div v-if="!!recur.t3" class="uk-width-1-1">
                                <select name="recur-times" class="uk-width-1-1 uk-margin-small-top uk-select recur-times" v-model="recur.p3">
                                    <option :value="value" v-for="value in timeRanges">Every {{value}} {{ recur.unit }}</option>
                                </select>
                            </div> -->
                        </div>

                        <div class="uk-width-1-1 uk-margin-top">
                            <h4>Your Information</h4>
                        </div>

                        <div class="uk-margin uk-grid-small uk-grid uk-text-left">
                            <div class="uk-width-1-2@m">
                                <label>First Name</label>
                                <input type="text" name="first_name" class="uk-input" placeholder="Name" />
                            </div>
                            <div class="uk-width-1-2@m">
                                <label>Last Name</label>
                                <input type="text" name="last_name" class="uk-input" placeholder="Last" />
                            </div>

                            <div class="uk-width-1-2@m">
                                <label>E-mail</label>
                                <input type="email" name="email" class="uk-input" placeholder="email@example.com" />
                            </div>
                            <div class="uk-width-1-2@m">
                                <label>Phone</label>
                                <div>
                                    <input type="tel" name="night_phone_a" class="uk-input phone1" placeholder="123" />
                                    <input type="tel" name="night_phone_b" class="uk-input phone1" placeholder="456"  />
                                    <input type="tel" name="night_phone_c" class="uk-input phone2" placeholder="7890" />
                                </div>
                            </div>

                            <div class="uk-width-1-1">
                                <label>Address</label>
                                <input type="text" name="address1" class="uk-input uk-margin-small-bottom" placeholder="Address" />
                                <input type="text" name="address2" class="uk-input" placeholder="Suite / Floor etc."/>
                            </div>

                            <div class="uk-grid uk-grid-small">
                                <div class="uk-width-1-3">
                                    <label>City</label>
                                    <input type="text" name="city" class="uk-input" placeholder="City" />
                                </div>

                                <div class="uk-width-1-3">
                                    <label>State</label>
                                    <select name="state" class="uk-select" required=""><option value="" disabled="">State</option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AS">American Samoa</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="AA">Armed Forces Americas</option><option value="AE">Armed Forces Europe</option><option value="AP">Armed Forces Pacific</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District of Columbia</option><option value="FM">Federated States of Micronesia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="GU">Guam</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MH">Marshall Islands</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="MP">Northern Mariana Islands</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PW">Palau</option><option value="PA">Pennsylvania</option><option value="PR">Puerto Rico</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VI">Virgin Islands</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option></select>
                                </div>

                                <div class="uk-width-1-3">
                                    <label>ZIP</label>
                                    <input type="text" name="zip" class="uk-input" placeholder="99999" />
                                </div>
                            </div>

                        </div>

                        <h3 class="uk-margin-remove">Your total: <b>${{amount}}</b>
                            <div v-if="recur.t3 && recur.p3">
                                <small class="uk-text-lowercase">repeated {{ recur.label }}</small>
                            </div>
                        </h3>

                        <input type="hidden" name="cmd" :value="!!recur.t3 ? '_xclick-subscriptions' : '_donations'">
                        <input type="hidden" name="bn" :value="buttonValue">
                        <input type="hidden" name="business" value="lmcconard@gmail.com">
                        <input type="hidden" name="currency_code" value="USD">
                        <input type="hidden" name="item_name" :value="itemName">
                        <input type="hidden" name="amount" :value="amount">
                        <input type="hidden" name="return" value="https://www.lowellmilkencenter.org/thank-you/">
                        <input type="hidden" name="rm" value="0">
                        <input type="hidden" name="cn" value="Leave us a message:">
                        <template v-if="!!recur.t3 && recur.t3!=''">
                            <input type="hidden" name="a3" :value="amount">
                            <input type="hidden" name="t3" :value="recur.t3">
                            <input type="hidden" name="p3" :value="recur.p3">
                            <input type="hidden" name="src" value="1">
                        </template>
                        <input type="hidden" name="image_url" value="https://www.lowellmilkencenter.org/_resources/themes/lmc/dist/images/LMC-Logo-DCC-White.png">

                        <div class="wp_pp_button_submit_btn uk-margin">
                            <input type="submit" name="submit" class="uk-button theme-button button-green uk-width-1" value="Proceed to PayPal">
                             <!-- :disabled="!shippingCountry" -->
                        </div>

                    </form>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() {
        return {
            amounts: [
                { value: 20, label: '$20' },
                { value: 36, label: '$36' },
                { value: 100, label: '$100' },
                { value: 250, label: '$250' },
                { value: 500, label: '$500' },
                { value: 1000, label: '$1000' },
                { value: 0, label: 'Custom Amount' }
            ],
            customAmount: 0.00,
            currentAmount: { value: 20, label: '$20' },
            recurrence: [
                { label: 'Just Once', t3: '', p3: ''},
                { label: 'Weekly', t3: 'W', p3: '1', max: 52, unit: "week(s)" },
                { label: 'Monthly', t3: 'M', p3: '1', max: 24, unit: "month(s)" },
                { label: 'Yearly', t3: 'Y', p3: '1', max: 5, unit: "year(s)" }
            ],
            recur: { label: 'Just Once', t3: '', p3: ''},
        }
    },
    computed: {
        amount() {
            return this.currentAmount.value ? parseFloat(this.currentAmount.value).toFixed(2) : parseFloat(this.customAmount).toFixed(2);
            return this.currentAmount.value ? parseFloat(this.currentAmount.value).toFixed(2) : parseFloat(this.customAmount).toFixed(2);
        },
        itemName() {
            return !!this.recur.t3 ? 'Recurring Donation' : 'One-time Donation';
        },
        buttonValue() {
            let service = !!this.recur.t3 ? 'Subscribe' : 'Donate';
            return `LowellMilkenCenter_${service}_WPS_US`;
        },
        timeRanges() {
            if(!!this.recur.t3) {
                return _.range(1, this.recur.max + 1)
            }
        }
    },
    watch: {
        customAmount(newValue) {
            if (/[^\.\d]/.test(newValue)) {
                this.customAmount = newValue.replace(/[^\.\d]/g, '');
            }
        }
    },
    inject: [ 'api', 'theme' ],
    props: ['page', 'parent']
}
</script>


<style>
.custom-amount {
     font-size: 2em;
     padding: 0.5em !important;
     border: 0 !important;
     min-width: 3em;
}
.item {
    border: 2px solid #2194c8  !important;
}
.item.active {
    background: #333 !important;
    color: #FFF !important;
}
.phone1 {
    width: 23%;
}
.phone2 {
    width: 50%;
}
.dollar-icon {
    font-size: 1.6em;
    color: rgba(255,255,255,0.3);
}
.donation-form-button {
    padding: 0;
    text-align: center;
}
</style>
